// 金额千分符展示
export const moneyFormatter = (value: string | number) =>
  `￥ ${value === '' ? '' : value || 0}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')

// 金额转数字
export const moneyParser = (value: string) => value.replace(/￥\s?|(,*)/g, '')

export const moneyFormatterNoUnit = (value: string | number) =>
  `${value === '' ? '' : value || 0}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')

// 手机号脱敏
export const phoneFormatter = (value: string) =>
  `${value || ''}`.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
export const moneyReplace = (value: string) => `${value || ''}`.replace(/[^\d]/g, '')
